import React, {useState, useEffect} from 'react';
import SegmentedButtonItem from './SegmentedButtonItem';
import './SegmentedButton.css';
import { useBlynkApi } from '../hooks/useBlynkApi';
import useBackEndWebHooks from '../hooks/useBackEndWebHooks';
import { useContext } from 'react';
import TokensContext from '../TokensContext';

const SegmentedButton = ( props ) => {
    const [selectedOption, setSelectedOption] = useState(null); // initial position unknown
    const {invertedHeater} = useContext(TokensContext);
    const {heaterToken} = props;

    const options = [
        { label: 'PILOTO', value: 1 }, 
        { label: 'MIN', value: 2 }, 
        { label: 'MAX', value: 3 }, 
    ];

    if (invertedHeater) { //flip the labels but keep their values.
        const aux = options[1].label;
        options[1].label = options[2].label;
        options[2].label = aux;
    }

    const {updateHeaterPosition, getHeaterPosition} = useBlynkApi(heaterToken);
    const {callPositionUpdatedWebHook} = useBackEndWebHooks();

    const handleOptionChange = async (value) => {
        setSelectedOption(value);
        await Promise.all([
             updateHeaterPosition(value),
             callPositionUpdatedWebHook(value),
        ]);
    }

    useEffect(() => {
        const fetchPosition = async () => {
            const currentPosition = await getHeaterPosition();
            setSelectedOption(currentPosition);
        };

        // Initial fetch and periodic refresh
        fetchPosition(); // Fetch immediately on mount
        const intervalId = setInterval(fetchPosition, 10000); // Refresh every 10 seconds

        return () => clearInterval(intervalId); // Cleanup on unmount
    }, [getHeaterPosition, heaterToken]); // Re-run effect if dependencies change

return (
    <div className='btn-group'>
        {options.map(({label, value }) => (
            <SegmentedButtonItem
                key={value}
                option={label}
                isSelected={value === selectedOption}
                onClick={() => handleOptionChange(value)}
            />
        ))}
    </div>
    );
};

export default SegmentedButton;